import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAllLegalMatterPracticeAreaAutocomplete } from './useLegalMatterPracticeAreaAutocomplete';

export const useCreateLegalMatterPracticeAreaMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.ILegalMatterPracticeArea) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			practiceArea,
			impersonationContext,
		}: {
			practiceArea: Api.ILegalMatterPracticeArea;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.ILegalMatterPracticeArea>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'legalMatter/practiceArea',
				}),
				'POST',
				practiceArea
			);
		},
		onError,
		onSuccess: data => {
			invalidateAllLegalMatterPracticeAreaAutocomplete();
			onSuccess?.(data);
		},
	});
};
